import dateService from '../../../../services/date-service';

const getDefaultState = () => ({
  filter: {
    date: {
      arrivalFromDate: dateService.getIsoDateString(dateService.lastYear()),
      arrivalToDate: dateService.getIsoDateString(dateService.today()),
      paidDateFromDate: dateService.getIsoDateString(dateService.lastYear()),
      paidDateToDate: dateService.getIsoDateString(dateService.today()),
    },
    data: {
      loading: false,
      error: false,
      selectedBrands: [],
      selectedDomains: [],
      brands: [],
      domains: [],
    },
    lastSearch: {
      performed: false,
      date: {},
      data: {},
    },
  },
  tableData: {
    rows: [],
    stays: [],
    loading: false,
    error: false,
    loaded: false,
  },
  download: {
    list: {
      loading: false,
      error: false,
    },
    specifications: {
      loading: false,
      error: false,
      name: undefined,
    },
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/payments/clientPayments/defaultState.js